import { createContext } from 'react'

export const layoutContext = createContext({ scrolled: false })
